export default {
    namespaced: true,

    state: {
        zones: []
    },

    getters: {

    },

    mutations: {
        set(state, data) {
            state.zones = data;
        }
    },

    actions: {
        update({commit}) {
            return this._vm.$api.getZones().then((data) => {
                commit('set', data);
            });
        },
    }
}